import { Stage } from "./stage";

function currentStageHelper(index : number, distanceTraveled : number, stages: Stage[], length : number): { index: number; remainder: number; stageReached: Stage;} | null {
  if(stages.length > 0) {
    if(distanceTraveled - stages[0].distance < 0) {
      return { index, remainder: stages[0].distance - distanceTraveled, stageReached: stages[0] }
    } else {
      return currentStageHelper(index + 1, distanceTraveled - stages[0].distance, stages.slice(1, length), length);
    }
  } else {
    return null;
  }
}

export function currentStage(distanceTraveled : number, stages : Stage[]) : { index: number; remainder: number; stageReached: Stage;} | null {
  return currentStageHelper(0, distanceTraveled, stages, stages.length);
}